// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2f94I","label":"SetPasswdForm_label__z1fd9"};